import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {

        const element = this.element;
        const lis = element.querySelectorAll("li");
        lis.forEach((li) => {
            li.addEventListener("click", (e) => {

                lis.forEach((l) => l.classList.remove("active"))
                li.classList.add("active");

                let ul = element.querySelector("ul");
                ul.classList.add("user-selected");
                setTimeout(() =>  ul.classList.remove("user-selected"), 100)

                const val = li.getAttribute("data-value");
                element.setAttribute("data-selected", val);

                element.querySelector('select').value = val;
            })
        })
    }
}
